const SectionDivider = () => (
    <div style={{ height: 1, backgroundColor: "#E6E8FA", alignSelf: "stretch" }} />
);

export default SectionDivider;